"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearHexString = exports.string2hex = exports.hex2string = exports.splitArrayIntoChunks = exports.hexStringToArrayBuffer = exports.buf2hex = void 0;
/* eslint-disable no-console */
/* eslint-disable eqeqeq */
/* eslint-disable no-param-reassign */
var buf2hex = function (buffer) {
    // buffer is an ArrayBuffer
    return Array.prototype.map
        .call(new Uint8Array(buffer), function (x) { return "00".concat(x.toString(16)).slice(-2); })
        .join('');
};
exports.buf2hex = buf2hex;
/**
 * Convert a hex string to an ArrayBuffer.
 *
 * @param {string} hexString - hex representation of bytes
 * @return {ArrayBuffer} - The bytes in an ArrayBuffer.
 */
var hexStringToArrayBuffer = function (hexString) {
    // remove the leading 0x
    hexString = hexString.replace(/^0x/, '');
    // ensure even number of characters
    if (hexString.length % 2 != 0) {
        console.log('WARNING: expecting an even number of characters in the hexString');
    }
    // check for some non-hex characters
    var bad = hexString.match(/[G-Z\s]/i);
    if (bad) {
        console.log('WARNING: found non-hex characters', bad);
    }
    // split the string into pairs of octets
    var pairs = hexString.match(/[\dA-F]{2}/gi);
    // convert the octets to integers
    var integers = pairs.map(function (s) { return parseInt(s, 16); });
    var array = new Uint8Array(integers);
    // console.log(array);
    return array.buffer;
};
exports.hexStringToArrayBuffer = hexStringToArrayBuffer;
var splitArrayIntoChunks = function (arr, len) {
    var chunks = [];
    var i = 0;
    var n = arr.byteLength;
    while (i < n)
        chunks.push(arr.slice(i, (i += len)));
    return chunks;
};
exports.splitArrayIntoChunks = splitArrayIntoChunks;
var hex2string = function (hex) {
    var decode = require('hex-encode-decode').decode;
    return decode(hex);
};
exports.hex2string = hex2string;
var string2hex = function (string) {
    var encode = require('hex-encode-decode').encode;
    return encode(string);
};
exports.string2hex = string2hex;
var clearHexString = function (hexString) {
    var clearHexString = hexString;
    var stringCleared = false;
    while (!stringCleared) {
        var advLen = clearHexString.length;
        if (clearHexString.substring(advLen - 2) == '00') {
            clearHexString = clearHexString.substring(0, advLen - 2);
        }
        else {
            stringCleared = true;
        }
    }
    return clearHexString;
};
exports.clearHexString = clearHexString;
